class InspectionDbService {
  public getUniqIdentifier(): string {
    const randomNum = Math.random().toString(35).slice(2);
    const atualMilli = (new Date()).getMilliseconds();

    return `${randomNum}${atualMilli}`;
  }
}

// eslint-disable-next-line import/no-anonymous-default-export
export default new InspectionDbService();
